import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import routes from "../../../app/routes";
import TotalRow from "./TotalRow";

export default function Payments({ cycle, memberId }) {
  const [collection, setCollection] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const updateCollection = () => {
    setLoaded(true);
    if (cycle != undefined) {
      axios
        .get(routes.api.member_benefit_payments.list, {
          params: { cycle_id: cycle.id, member_id: memberId },
        })
        .then((resp) => {
          setCollection(resp.data.data);
          setLoaded(false);
        });
    }
  };

  useEffect(() => {
    updateCollection();
  }, [cycle]);

  const columns = [
    {
      name: "Date",
      selector: "attributes.format_date",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.formated_date_int - b.attributes.formated_date_int,
    },
    {
      name: "Payment #",
      selector: "attributes.number",
      sortable: true,
    },
    {
      name: "Deduction",
      selector: "attributes.format_deduction",
      sortable: true,
      right: true,
    },
  ];

  return (
    <div className="row">
      <div className="col-md-8 col-md-offset-2">
        {loaded && <p className="text-center mt20">Processing...</p>}

        {!loaded && (
          <>
            <DataTable
              title=""
              columns={columns}
              data={collection}
              noDataComponent="No matching records found"
              persistTableHead={true}
            />
            {collection.length > 0 && (
              <TotalRow cycle={cycle} collection={collection} />
            )}
            {collection.length > 0 && (
              <div className="text-right mt20">
                <a
                  target="_blank"
                  href={routes.api.member_benefit_payments.report(
                    memberId,
                    cycle.id
                  )}
                  className="btn btn-green"
                >
                  Download PDF
                </a>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
